export const INVOICE_STATUS = {
	UNPAID: 'UNPAID',
	PAID: 'PAID',
	CANCELED: 'CANCELED',
}

export const INVOICE_TYPE = {
	ORDER_PAYMENT: 'ORDER_PAYMENT',
	POST_PAYMENT: 'POST_PAYMENT',
}

export const isPostPaymentInvoice = invoice => invoice?.type === INVOICE_TYPE.POST_PAYMENT

export const getInvoiceViewStatus = invoice => {
	if (Object.values(INVOICE_STATUS).includes(invoice?.status)) {
		return invoice.status
	}
	return invoice?.markAsPaid ? INVOICE_STATUS.PAID : INVOICE_STATUS.UNPAID
}
